import { RsvpAnswerDto } from "../../../models/api/rsvpApiTypes"
import BooleanSwitch from "../BooleanSwitch"
import DateInput from "../DateInput"
import TextInput from "../TextInput"

interface DynamicInputProps {
  inputType: string | null | undefined
  placeholder?: string
  answer?: RsvpAnswerDto
  onUpdate: (patch: Partial<RsvpAnswerDto>) => void
}

function parseDateValue(dateValue: string | null | undefined): Date | null {
  if (!dateValue) {
    return null
  }

  const parsedDate = new Date(dateValue)
  if (Number.isNaN(parsedDate.getTime())) {
    return null
  }

  return parsedDate
}

export default function DynamicInput({ inputType, placeholder, answer, onUpdate }: DynamicInputProps) {
  if (inputType === "Boolean") {
    return (
      <BooleanSwitch
        checked={answer?.booleanValue}
        onChange={(checked) => onUpdate({ booleanValue: checked })}
      />
    )
  }

  if (inputType === "Date") {
    return (
      <DateInput
        selected={parseDateValue(answer?.dateValue)}
        onChange={(date) => onUpdate({ dateValue: date ? date.toISOString() : null } as Partial<RsvpAnswerDto>)}
      />
    )
  }

  return (
    <TextInput
      value={answer?.textValue ?? null}
      placeholder={placeholder}
      onChange={(value) => onUpdate({ textValue: value } as Partial<RsvpAnswerDto>)}
    />
  )
}